<template>
  <div class="view contentBody">
    <div class="content">
      <div class="content-tab-box">
        <span :class="meaulistTab.firstTab==item?'content-tab-box-active':''" @click="tabCurrentFn(item)"
              v-for="(item,index) in meaulistTab.tab" :key="item">{{index}}</span>
      </div>
      <div v-for="item in meaulistTab.tab" :key="item">
        <component v-bind:is="item" v-if="meaulistTab.firstTab==item"></component>
      </div>
      <!-- <el-tab-pane label="商品咨询设置" name="consultationSetting">
        <consultationSetting v-if="activeName==='consultationSetting'"></consultationSetting>
      </el-tab-pane>-->
    </div>
  </div>
</template>
<script>
  import offlineCommissionSetting from "./offlineCommissionSetting.vue";
  import consultationSetting from "./consultationSetting.vue";
  import basicSettings from "./basicSettings.vue";
  import aftersalesSettings from "./aftersalesSettings.vue";
  import shoppingCartSetting from "./shoppingCartSetting.vue";
  import goodsTags from "./goodsTags.vue";
  import goodsNotice from "./goodsNotice.vue";
  import orderSettings from "./orderSettings.vue";
  let tabBox = {
    '基础设置': {property: 'basicSettings'},
    '售后设置': {property: 'aftersalesSettings'},
    '线下提成设置': {property: 'offlineCommissionSetting'},
    '购物车按钮配置': {property: 'shoppingCartSetting'},
    '商城标签': {property: 'goodsTags'},
    '商城公告': {property: 'goodsNotice'},
    '订单设置': {property: 'orderSettings'}
  }

  export default {
    name: "settings",
    components: {
      offlineCommissionSetting,
      consultationSetting,
      basicSettings,
      aftersalesSettings,
      shoppingCartSetting,
      goodsTags,
      goodsNotice,
      orderSettings
    },
    data() {
      return {
        meaulistTab: this.meaulist.meaulistGet(this, tabBox),
        activeName:''
      };
    },
    created() {
      this.inittab();
    },
    methods: {
      inittab() {
        this.activeName =
            this.$route.query.tab !== undefined
                ? this.$route.query.tab
                : "basicSettings";
      },
      tabCurrentFn(index){
        // console.log('====',index)
        this.meaulistTab.firstTab = index
      }
    }
  };
</script>
